import './BrandLockup.css';

const BrandLockup = ({ className = '', title = 'Dashboard' }) => {
  const classes = ['brand-lockup', className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <img src="/gravvisoft-mark.svg" alt="GravviSoft logo" className="brand-lockup__mark" />
      <span className="brand-lockup__text">
        <span className="brand-lockup__eyebrow">GRAVVISOFT</span>
        <span className="brand-lockup__title">{title}</span>
      </span>
    </div>
  );
};

export default BrandLockup;
